import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, Settings, Briefcase, LayoutDashboard } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";
import { AccountSettings } from "@/components/AccountSettings";

export const Navbar = ({ title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-[#050505] border-b border-[#2A2A2A]">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12 py-4 flex items-center justify-between gap-6">
        <div className="flex items-center gap-5">
          <img src={LOGO_URL} alt="Splash Creative Hub" className="w-[150px] h-auto object-contain" />
          <span className="hidden sm:block text-xs uppercase tracking-[0.25em] text-[#A1A1AA] border-l border-[#2A2A2A] pl-5 leading-relaxed">
            {title}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-medium text-white leading-tight">{user?.name}</div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-[#FF4D00]">{user?.role}</div>
          </div>
          {user?.role === "admin" && (
            location.pathname.startsWith("/admin") ? (
              <button data-testid="nav-my-work" onClick={() => navigate("/portal")} title="Your assigned work" className="flex items-center gap-2 border border-[#2A2A2A] px-3 py-2 text-sm text-white hover:bg-[#111111] transition-colors">
                <Briefcase className="w-4 h-4" /> <span className="hidden sm:inline">My Work</span>
              </button>
            ) : (
              <button data-testid="nav-admin" onClick={() => navigate("/admin")} title="Admin dashboard" className="flex items-center gap-2 border border-[#2A2A2A] px-3 py-2 text-sm text-white hover:bg-[#111111] transition-colors">
                <LayoutDashboard className="w-4 h-4" /> <span className="hidden sm:inline">Admin</span>
              </button>
            )
          )}
          <button
            data-testid="account-settings-btn"
            onClick={() => setSettingsOpen(true)}
            title="Account settings"
            className="flex items-center gap-2 border border-[#2A2A2A] px-3 py-2 text-sm text-white hover:bg-[#111111] transition-colors"
          >
            <Settings className="w-4 h-4" /> <span className="hidden sm:inline">Settings</span>
          </button>
          <button
            data-testid="logout-btn"
            onClick={async () => { await logout(); navigate("/login"); }}
            className="flex items-center gap-2 border border-[#2A2A2A] px-3 py-2 text-sm text-white hover:bg-[#111111] transition-colors"
          >
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
      {settingsOpen && <AccountSettings onClose={() => setSettingsOpen(false)} />}
    </header>
  );
};
